import { render, staticRenderFns } from "./ElementNotification.vue?vue&type=template&id=610c9957&scoped=true"
import script from "./ElementNotification.vue?vue&type=script&lang=js"
export * from "./ElementNotification.vue?vue&type=script&lang=js"
import style0 from "./ElementNotification.vue?vue&type=style&index=0&id=610c9957&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610c9957",
  null
  
)

export default component.exports